import { useEffect, useState, useCallback } from "react";
import Cookies from "js-cookie";
import { getApi } from "../utils/api.ts";
import { API_GET_EMPLOYEE_PROFILE_IMAGE } from "../../config/Endpoints";
import { Event } from "../../config/events";

export const useProfileImage = (userId?: string | number) => {
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const accessToken = Cookies.get("accessToken");

  const fetchImage = useCallback(async () => {
    if (!userId) return;
    try {
      const res = await getApi<Blob>(
        `${API_GET_EMPLOYEE_PROFILE_IMAGE}/${userId}?t=${new Date().getTime()}`,
        accessToken,
        "blob"
      );

      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result as string);
      };
      reader.readAsDataURL(res.data);
    } catch {
      setProfileImage(null);
    }
  }, [userId, accessToken]);

  useEffect(() => {
    fetchImage();

    const handleUpdate = () => {
      fetchImage();
    };

    window.addEventListener(Event.USER.PROFILE_IMAGE_UPDATED, handleUpdate);
    return () => {
      window.removeEventListener(Event.USER.PROFILE_IMAGE_UPDATED, handleUpdate);
    };
  }, [fetchImage]);

  return profileImage;
};